import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/brain/entity/$entityId')({}).lazy(() =>
  import('./$entityId.lazy').then((d) => d.Route),
);
